module.exports = "/static/media/dtmf-9.426be99c.mp3";